<template>
    <div class="adminBoard">
        <div class="ab-header">
            <font-awesome-icon :icon="icons.admin" class="fa-3x"></font-awesome-icon>
            <div class="ab-header-title">{{$t('admin.header.title')}}</div>
        </div>
        <div class="ab-body">
            <v-tabs vertical>
                <v-tab>{{$t('admin.body.tabs.users')}}</v-tab>
                <v-tab>{{$t('admin.body.tabs.invitations')}}</v-tab>
                <v-tab>{{$t('admin.body.tabs.comments')}}</v-tab>
                <v-tab>{{$t('admin.body.tabs.usage')}}</v-tab>
                <v-tab>{{$t('admin.body.tabs.maintenance')}}</v-tab>
                <v-tab>{{$t('admin.body.tabs.tests')}}</v-tab>
                <v-tab-item>
                    <div class="ab-tab">
                        <UsersSection></UsersSection>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="ab-tab">
                        <InvitePanel></InvitePanel>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="ab-tab">
                        <CommentSection></CommentSection>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="ab-tab">
                        <UsageSection></UsageSection>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="ab-tab">
                        <MaintenanceSection ref="maintenance"></MaintenanceSection>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="ab-tab">
                        <TestsSection></TestsSection>
                    </div>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import AdministrationPageMixin from './AdministrationPageMixin'
import UserDataHelperMixin from '../../infra/UserDataHelperMixin'
export default {
    mixins: [AdministrationPageMixin, UserDataHelperMixin]
}
</script>

<style scoped>
.adminPage {
    height: 100%;
    background-color: var(--lightBG);
}
.adminBoard {
    display: flex;
    flex-direction: column;
    font-size: large;
    padding: 0 50px;
}
.ab-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    font-size: xx-large;
}
.ab-header-title {
    margin-left: 30px;
}
.ab-body {
    width: 100%;
    max-width: 1600px;
    margin: auto;
}
.ab-tab {
    background-color: var(--darkBG);
    border-radius: 10px;
}
</style>
